export const coinsBaseUrl = `https://api.coingecko.com/api/v3/`